<template>
  <privacy-policy-list
    @deletePrivacyPolicyConfigurationClick="deletePrivacyPolicyConfigurationClick($event)"
    @loadData="loadData($event)"
    @savePrivacyPolicy="savePrivacyPolicy($event)"
    :privacyPolicyConfigurations="privacyPolicyConfigurations"
    :privacyPolicyStatesLoading="privacyPolicyStatesLoading"
  ></privacy-policy-list>
</template>

<script>
import PrivacyPolicyList from '../../components/PrivacyPolicyList.vue';

export default {
  name: 'list-privacy-policy-view',
  components: { PrivacyPolicyList },
  data() {
    return {
      privacyPolicyStatesLoading: false,
      privacyPolicyConfigurations: [],
    };
  },
  methods: {
    async listPrivacyPolicyConfigurations({ bookingChannelId }) {
      this.privacyPolicyStatesLoading = true;
      this.privacyPolicyConfigurations = await this.$store.dispatch('bookingChannel/getBookingChannelPrivacyPolicyList', {
        bookingChannelId,
      });
      this.privacyPolicyStatesLoading = false;
    },
    async deletePrivacyPolicyConfiguration({ bookingChannelId, privacyPolicyId }) {
      this.privacyPolicyStatesLoading = true;
      const result = await this.$store.dispatch('bookingChannel/deleteBookingChannelPrivacyPolicy', {
        bookingChannelId,
        privacyPolicyId,
      });

      if (result) {
        this.privacyPolicyConfigurations = this.privacyPolicyConfigurations.filter(privacyPolicyConfiguration => privacyPolicyConfiguration.id !== privacyPolicyId);
      }

      this.privacyPolicyStatesLoading = false;
    },
    async deletePrivacyPolicyConfigurationClick(privacyPolicyConfiguration) {
      await this.deletePrivacyPolicyConfiguration({
        bookingChannelId: this.$store.state.bookingChannel.id,
        privacyPolicyId: privacyPolicyConfiguration.id,
      });
    },
    savePrivacyPolicy(privacyPolicyConfiguration) {
      this.privacyPolicyConfigurations.push(privacyPolicyConfiguration);
    },
    async loadData() {
      await this.listPrivacyPolicyConfigurations({
        bookingChannelId: this.$store.state.bookingChannel.id,
      });
    },
  },
};
</script>
